import addSeconds from 'date-fns/addSeconds';
import fromUnixTime from 'date-fns/fromUnixTime';
import flow from 'lodash/flow';

export const MILLISECONDS_PER_SECOND = 1000; // a true constant :)
export const XSRF_COOKIE_SOURCE_DELIMITER = '!';
export const DEFAULT_SECONDS_UNTIL_IDLE = 60; // NOTE - if no FH cookie, then assume session active [PASS-3500]

export interface SessionExpirySource {
  cookies: Record<string, string>;
  cookieName: string;
}
/** Reads the cookie collection for the given auth cookie name (defaults to FH) to determine
 * when the session will end.
 */
export const getSessionExpiry = (expirySource: SessionExpirySource) => {
  try {
    const { cookies, cookieName } = expirySource;
    const srcCookie = cookies[cookieName];
    const [_, issuedAtSeconds, ttlSeconds] = srcCookie.split(
      XSRF_COOKIE_SOURCE_DELIMITER,
    );
    if (!issuedAtSeconds) {
      throw new Error('invalid cookie format');
    }
    // prettier-ignore
    return flow(
      Number,
      fromUnixTime,
      (issueDate) => addSeconds(issueDate, Number(ttlSeconds))
    )(issuedAtSeconds);
  } catch (e) {
    console.error(
      'An error occurred determining session expiry, using defaults.',
      e,
    );
    return addSeconds(new Date(Date.now()), DEFAULT_SECONDS_UNTIL_IDLE);
  }
};
